export default function Node_GetStarted() {
  return <div>Node_GetStarted Component</div>;
}
